export const sidebarTranslation = {
  fi: {
    SideBar: {
      home: 'Etusivu',
      devices: 'Älylääkekaapit',
      departments: 'Osastot',
      deviceUsers: 'Käyttäjät',
      users: 'Adminit',
      events: 'Tapahtumat',
      changePassword: 'Vaihda salasana',
      twoFactor: 'Kaksivaiheinen tunnistautuminen',
      logout: 'Kirjaudu ulos',
    },
  },
};
